import { Observable } from "rxjs";
import NetworkService from "../network/networkService";
import { AgTechQueryParam, OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import { ITrialExperimentsAllResponse } from "../models/ITrialExperiments.model";
import { URLConfig } from "../network/urlStore";

export const getTrialExperiments = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<ITrialExperimentsAllResponse> => {
  let url = URLConfig.getTrialExperimentsUrl();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ITrialExperimentsAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching trial experiments data", error);
      }
    );
  });
};

export const getTrialExperimentsNextPage = (
  nextPageURI: string
): Observable<ITrialExperimentsAllResponse> => {
  const url = URLConfig.getTrialExperimentsNextPage(nextPageURI);
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res) => {
        if (res) {
          const trialResponse = res as unknown as ITrialExperimentsAllResponse;
          subscriber.next(trialResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching trial experiments next page data", error);
      }
    );
  });
};

export const getContentLengthForTrialExperiments = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getTrialExperimentsUrl();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then(
        (res: any) => {
          subscriber.next(res?.contentLength ?? 0);
          subscriber.complete();
        },
        (error: Error) => {
          subscriber.error(error);
          console.log("Error while getContentLengthForTrialExperiments", error);
        }
      )
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};

export const getTrialExperimentById = (id: string): Observable<any> => {
  const url = URLConfig.getTrialExperimentByIdUrl(id);
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          subscriber.next(res);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching trial experiment details", error);
      }
    );
  });
};

export const getAgronomicData = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<any> => {
  let url = URLConfig.getAgronomicData();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res) => {
        if (res) {
          const trialResponse = res as unknown as ITrialExperimentsAllResponse;
          subscriber.next(trialResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching trial experiments next page data", error);
      }
    );
  });
};
export const getAgronomicDataNextPage = (
  nextPageURI: string
): Observable<any> => {
  const url = URLConfig.getAgronomicDataNextPage(nextPageURI);
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res) => {
        if (res) {
          const trialResponse = res as unknown as ITrialExperimentsAllResponse;
          subscriber.next(trialResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching trial experiments next page data", error);
      }
    );
  });
};

export const updateAgronomicData = (
  requestPayload: any,
  id: string
): Observable<any> => {
  const url = `${URLConfig.getAgronomicData()}/TrialExpId/${id}`;

  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (res) => {
        const response = res as unknown as any;
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating trialfield", error);
      }
    );
  });
};
export const discardPlotTrialExperiment= (
  requestPayload: any,
  id: string
): Observable<any> => {
  const url = `${URLConfig.getTrialExperimentDiscardPlotURL(id)}`;

  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (res) => {
        const response = res as unknown as any;
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating trialfield", error);
      }
    );
  });
};
export const getHarvestData = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<any> => {
  let url = URLConfig.getHarvestData();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res) => {
        if (res) {
          const trialResponse = res as unknown as ITrialExperimentsAllResponse;
          subscriber.next(trialResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching trial experiments next page data", error);
      }
    );
  });
};
export const getHarvestDataNextPage = (
  nextPageURI: string
): Observable<any> => {
  const url = URLConfig.getAgronomicDataNextPage(nextPageURI);
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res) => {
        if (res) {
          const trialResponse = res as unknown as ITrialExperimentsAllResponse;
          subscriber.next(trialResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching trial experiments next page data", error);
      }
    );
  });
};

export const updateHarvestData = (
  requestPayload: any,
  id: string
): Observable<any> => {
  const url = `${URLConfig.getHarvestData()}/TrialExpId/${id}`;

  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (res) => {
        const response = res as unknown as any;
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating harvest data", error);
      }
    );
  });
};

export const getContentLengthForAgronomicData = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getAgronomicData();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};

export const getContentLengthForHarvestData = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getHarvestData();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};
export const updateTrialExperiments = (
  requestPayload: any, id: string): Observable<ITrialExperimentsAllResponse> => {
  const url = `${URLConfig.getTrialExperimentsUrl()}/${id}`;
  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ITrialExperimentsAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while updating trial experiments data", error);
      }
    );
  });
}
export const createTrialExperiments = (
  requestPayload: any,
): Observable<any> => {
  let url = URLConfig.getTrialExperimentsUrl();

  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload).then(
      (res) => {
        const response = res as unknown as any;
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating harvest data", error);
      }
    );
  });
};

export const deleteTrialExperiment = (onFarmTrialLocationId: string): Observable<any> => {
  const url = URLConfig.deleteOnFarmTrialExperimentUrl(onFarmTrialLocationId);
  return new Observable((subscriber) => {
    NetworkService.delete(url).then(
      (res: unknown) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while deleting the trial experiment", error);
      }
    );
  });
};